import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Immutable from "immutable";
import { translate } from "react-i18next";
import reduxForm from "redux-form/lib/reduxForm";
import formValueSelector from "redux-form/lib/formValueSelector";
import $ from "jquery";

import { initialize as initCart } from "../../store/modules/cart";
import CartDrawerItem from "./CartDrawerItem";
import { VK_ESCAPE } from "../../lib/constants";

import "./CartDrawer.scss";

/**
 * CartDrawer
 */
class CartDrawerContainer extends Component {
  static propTypes = {
    shouldInitialize: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    quantity: PropTypes.number,
    initCart: PropTypes.func.isRequired,
    cartUrl: PropTypes.string.isRequired,
    hasFetchedContext: PropTypes.bool.isRequired,
    items: PropTypes.instanceOf(Immutable.List).isRequired
  };

  static defaultProps = {
    quantity: 0
  };

  state = {
    toggleDrawers: false
  };

  componentWillMount() {
    if (this.props.shouldInitialize) {
      this.props.initCart();
    }
    // on document so escape keydown works.. it won't work on window
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("click", this.onDocumentClick);
  }

  componentWillReceiveProps(props) {
    if (props.items && props.items.size === 0) {
      this.setState({ toggleDrawers: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("click", this.onDocumentClick);
  }

  onDocumentClick = e => {
    if (
      $(e.target).hasClass("CartDrawer__Cover") &&
      $(e.currentTarget)
        .find("body")
        .hasClass("drawer--open")
    ) {
      this.onToggleDrawer(e);
    }
  };

  onKeyDown = e => {
    if (this.state.toggleDrawers && e.keyCode === VK_ESCAPE) {
      this.onToggleDrawer(e);
    }
  };

  onToggleDrawer = e => {
    $("body").toggleClass("drawer--open", !this.state.toggleDrawers);
    this.setState({ toggleDrawers: !this.state.toggleDrawers });
    $(window).trigger("debloemist.drawer.toggled");
    e.preventDefault();
    return false;
  };

  onClickCheckout = () => {
    if (this.props.items.size === 1) {
      document.location = this.props.cartUrl;
      return false;
    }
    return true;
  };

  render() {
    if (!this.props.hasFetchedContext) {
      return null;
    }
    const { t } = this.props;

    const isCartEmpty = this.props.items.size === 0;

    return (
      <div>
        <a
          className={["shoppingcart", this.props.quantity > 0 && "shoppingcart--active"].filter(v => !!v).join(" ")}
          href="/cart"
          onClick={this.onToggleDrawer}
        >
          <i className="fa fa-shopping-cart" />
          <div className="shoppingcart__indicator">
            <i className="fa fa-circle" />
            <span className="shoppingcart__indicator__quantity">{this.props.quantity}</span>
          </div>
        </a>
        {this.state.toggleDrawers && (
          <div className="CartDrawer">
            <div className="CartDrawer__Cover" />
            <div className="CartDrawer__Container">
              <div className="CartDrawer__Header">
                <div>{this.props.t("Cart")}</div>
                <button onClick={this.onToggleDrawer}>
                  <i className="fa fa-times" />
                </button>
              </div>
              {isCartEmpty && <div className="CartDrawer__GroupedCartItem">{t("Your cart is empty")}</div>}
              <div className="CartDrawer__CartItems">
                {this.props.items.map((item, idx) => (
                  <div className="CartDrawer__GroupedCartItem" key={`${item.get("uuid")}`}>
                    <CartDrawerItem item={item.set("itemIndex", idx)} />
                    {item.get("extraProducts").map((p, pIdx) => (
                      <CartDrawerItem
                        key={p.get("uuid")}
                        item={p.set("parentItemIndex", idx).set("itemIndex", pIdx)}
                        extraProduct
                      />
                    ))}
                  </div>
                ))}
              </div>
              <div className="CartDrawer__Buttons">
                <a className="btn btn-inverted mr-3" href="/">
                  {t("Continue shopping")}
                </a>
                {!isCartEmpty && (
                  <a className="btn btn-secondary" href="/cart" onClick={this.onClickCheckout}>
                    {t("Complete order")}
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const cartFormValueSelector = formValueSelector("cart");

const selectCartFormItemsData = createSelector([state => cartFormValueSelector(state, "items")], cart =>
  Immutable.fromJS(cart)
);

const selectCartContext = createSelector([state => state.cart], cart => cart.get("context"));

const EMPTY_LIST = Immutable.List();

const selectCartItems = createSelector(
  [state => selectCartFormItemsData(state), state => selectCartContext(state)],
  (items, context) => {
    const itemContexts = context.get("itemContexts");
    if (!itemContexts || !items) {
      return EMPTY_LIST;
    }
    return items
      .map(item => {
        const itemContext = itemContexts.find(ctx => ctx.get("webProductId") === item.get("webProductId"));
        if (!itemContext) {
          return null;
        }
        let pcm = itemContext.get("items").find(i => i.get("id") === item.get("productCollectionMemberId"));
        if (!pcm) {
          return null;
        }

        pcm = pcm.set("uuid", item.get("uuid"));
        pcm = pcm.set("webProductId", item.get("webProductId"));
        pcm = pcm.set("title", `${pcm.get("title")}`);
        pcm = pcm.set("quantity", item.get("quantity"));
        pcm = pcm.set("imageId", itemContext.get("imageId"));
        pcm = pcm.set("imageVersionId", itemContext.get("imageVersionId"));

        const extraProducts = itemContext.get("extraProducts");
        pcm = pcm.set(
          "extraProducts",
          item
            .get("extraProducts")
            .map(p => {
              const ep = extraProducts.find(i => i.get("id") === p.get("id"));
              if (!ep) {
                return null;
              }
              return ep.set("uuid", p.get("uuid")).set("quantity", item.get("quantity"));
            })
            .filter(v => !!v)
        );
        return pcm;
      })
      .filter(v => !!v);
  }
);

const selectCartQuantity = createSelector([state => selectCartItems(state, "items")], items => {
  if (!items) {
    return 0;
  }
  return Immutable.fromJS(items).reduce((carry, item) => {
    carry = carry + item.get("quantity") + item.get("extraProducts").size;
    return carry;
  }, 0);
});

export default translate()(
  connect(
    state => ({
      shouldInitialize: !state.cart.get("hasInitialized") && !state.cart.get("isInitializing"),
      initialValues: state.cart.get("data").toJS(),
      cartUrl: state.cart.getIn(["context", "itemContexts", 0, "url"], ""),
      hasCurrentItemContext: state.cart.getIn(["context", "currentItemContext"]) !== null,
      hasFetchedContext: state.cart.get("hasFetchedContext", false),
      items: selectCartItems(state),
      quantity: selectCartQuantity(state)
    }),
    {
      initCart
    }
  )(
    reduxForm({
      form: "cart"
    })(CartDrawerContainer)
  )
);
